import * as types from './mutation-types';
import {
	SEARCH_PARAMS,
	PAGING_INFO,
	DETAIL_FORM,
	PART_MST_INFO,
	HISTORY_PAGING_INFO,
	SEARCH_POPUP_PARAMS,
	PPR_NO_PAGING_INFO
} from './state';

export default {
	[types.STATE_INIT]: state => {
		state.lugyCdList = []; //긴급도 selectBox
		state.pgsStPcCdList = []; //진행상태 selectBox
		state.pgsStLpCdList = []; //진행상태 selectBox
		state.pgsStKdCdList = []; //진행상태(KD) selectBox
		state.badTypeLgrpCdList = []; //유형 selectBox
		state.occuPlCdList = []; //발생장소 selectBox
		state.rptpPrcsCdList = []; //고품처리 selectBox
		state.mdvRplCdList = []; //대책회신 selectBox
		state.partGCdList = []; //소싱구분 selectBox
		state.sndStCdList = []; //메일발송상태 selectBox

		state.clmPgsStCdList = []; //클래임 진행상태
		state.clmRsltCdList = []; //판정결과
		state.judgedStateList = []; //판정진행상태
		state.tpWayCdList = []; //운송수단
		state.clmTypeCdList = []; //클래임유형

		state.useYnList = [];
		state.resultList = [];
		state.partCkuScrId = ''; // 부품검사 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
		state.searchParams = SEARCH_PARAMS();
		state.searchPopupParams = SEARCH_POPUP_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.detailForm = DETAIL_FORM();
		state.badTypeLv1List = [];
		state.badTypeLv2List = [];
		state.badTypeLv3List = [];
		state.rcptInfo = new Map(); //수신자 메일정보
		state.rfpInfo = new Map(); //참조자 메일정보
		state.partMstInfo = PART_MST_INFO();
		state.glimsFileList = []; // Glims fileList
		state.pprHistoryList = []; //개선이력 목록,
		state.historyPagingInfo = HISTORY_PAGING_INFO(); //개정이력 페이징
		state.pprNoPagingInfo = PPR_NO_PAGING_INFO(); //

		state.feTarget = '';
		state.ubiTarget = '';
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.SEARCH_POPUP_PARAMS]: (state, { key, value }) => {
		state.searchPopupParams[key] = value;
	},
	[types.SEARCH_POPUP_PARAM]: (state, { key, value }) => {
		state.searchPopupParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.PPR_NO_PAGING_INFO]: (state, { key, value }) => {
		//console.log('key, value >>>', key, value);
		state.pprNoPagingInfo[key] = value;
	},
	[types.PPR_NO_SEARCH_POPUP]: (state, { key, value }) => {
		state.PPR_NO_SEARCH_POPUP[key] = value;
	},
	[types.POPUP_INIT]: state => {
		state.detailForm = DETAIL_FORM();
	},
	[types.SET_FORM]: (state, { key, value }) => {
		state.detailForm[key] = value;
	},
	[types.BAD_TYPE_POPUP_INIT]: state => {
		state.badTypeLv1List = [];
		state.badTypeLv2List = [];
		state.badTypeLv3List = [];
	},
	[types.HISTORY_PAGING_INFO]: (state, { key, value }) => {
		state.historyPagingInfo[key] = value;
	},
	[types.HISTORY_POPUP_INIT]: state => {
		state.detailForm = HISTORY_PAGING_INFO();
	}
};
